import React from "react";

interface RaindropHeadingProps {
  title: string;
  emoji?: string;
  isSecondary: boolean;
  isCentered?: boolean;
  className?: string;
}

const RaindropHeading: React.FC<RaindropHeadingProps> = ({
  title,
  emoji = "",
  isSecondary = false,
  isCentered = false,
  className = "",
}) => {
  let textClass = "dark:text-color-dark-text-primary text-lg";
  let centeringClass = "text-left";

  if (isSecondary) {
    textClass = "text-color-dark-text-secondary text-sm uppercase";
  }

  if (isCentered) {
    centeringClass = "text-center";
  }

  return (
    <div
      className={`flex flex-row gap-2 w-full ${centeringClass} items-center ${className}`}
    >
      {emoji && <div className="text-3xl">{emoji}</div>}
      <h1 className={`font-extrabold ${textClass}  ${centeringClass}`}>
        {title}
      </h1>
    </div>
  );
};

export default RaindropHeading;
